module.exports = __webpack_public_path__ + "img/logistics.e64a8120.svg";